/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is the monthly payment calculated?`)
};

const es_ln_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se calcula el pago mensual?`)
};

const de_ln_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird die monatliche Rate berechnet?`)
};

const nl_ln_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt de maandelijkse betaling berekend?`)
};

const fr_ln_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment le paiement mensuel est-il calculé?`)
};

const it_ln_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come viene calcolato il pagamento mensile?`)
};

const pt_br2_ln_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como o pagamento mensal é calculado?`)
};

const pt_ln_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é calculado o pagamento mensal?`)
};

const ja_ln_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「月々支払額はどのように計算されますか？」`)
};

const zh_ln_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月供是如何计算的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_faq1_q", locale)
	if (locale === "en") return en_ln_faq1_q(inputs)
	if (locale === "es") return es_ln_faq1_q(inputs)
	if (locale === "de") return de_ln_faq1_q(inputs)
	if (locale === "nl") return nl_ln_faq1_q(inputs)
	if (locale === "fr") return fr_ln_faq1_q(inputs)
	if (locale === "it") return it_ln_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_ln_faq1_q(inputs)
	if (locale === "pt") return pt_ln_faq1_q(inputs)
	if (locale === "ja") return ja_ln_faq1_q(inputs)
	return zh_ln_faq1_q(inputs)
};